// IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B): чистая логика утверждения планов ЗП / DO из отчёта
// «Баланс постачання та попиту» (прототип handoff-tools/2026-10-30/plan_approval_proto, контракт бэка — plan.md §4, BE PR #979, common_modules/plan_approval_v3):
//   1) кнопка «Plan approval» шапки (AttrGrid.planApproval_button): чипы по видам планов (PURCHASE-PLAN / DISTR-PLAN) из plan_decision_summary, цвет — худший state,
//      меню по видам: Approve / Processed until… / Confirm (approved-changed) / Withdraw / History; скоуп {objects, segment} — позиции отбора отчёта;
//   2) раздел «PLAN DECISION» формы ячейки строки плана (Dropdown): состояние ключа (последнее событие plan_decision_history), радио Approve whole horizon /
//      Processed until date / Withdraw, причина (PLAN-DECISION-REASON), комментарий; скоуп {where, month} — как у cell_passport;
//   3) пилюля статуса и замок в заголовке строки плана: decision строки (DS-PLAN-DOCS — этап C бэка, поля ещё нет), иначе сводка вида плана с ОДНОЙ позицией в отборе.
// Любая запись — сначала plan_decision с dry: true (список позиций), подтверждение, затем настоящий вызов (planApproval_decide).
// Без Vue / DOM — юнит-тест tests/unit/planApproval.test.mjs. Флаг fe.ux.planApproval (дефолт ВКЛ; выкл — ни кнопки, ни раздела, ни пилюли).
import { t, tn } from '@/i18n'

export const PLAN_APPROVAL_FLAG = 'fe.ux.planApproval'
export const SEGMENTS = ['PURCHASE-PLAN', 'DISTR-PLAN']
export const METHODS = { decide: 'plan_decision', summary: 'plan_decision_summary', history: 'plan_decision_history' }
export const DECISIONS = ['process_until', 'approve', 'confirm', 'withdraw']
export const STATES = ['autoplan', 'processed', 'approved', 'approved-changed', 'withdrawn']
export const ACTIVE = ['processed', 'approved', 'approved-changed']
export const REASON_SEGMENT = 'PLAN-DECISION-REASON'
// причины по умолчанию (= config_predefined_approval.PLAN_DECISION_REASONS бэка), пока справочник не загружен в itemsSource
export const DEFAULT_REASONS = [
    { id: 'pdr-supplier-unconfirmed', title: 'Supplier has not confirmed the batch' },
    { id: 'pdr-no-budget', title: 'No budget for the period' },
    { id: 'pdr-wait-sales-plan', title: 'Waiting for the sales plan' },
    { id: 'pdr-other', title: 'Other' },
]
const RANK = { autoplan: 0, withdrawn: 0, approved: 1, processed: 2, 'approved-changed': 3 }   // = plan_approval_v3.STATE_RANK: «худший» — больше
const ALIAS = { PO: 'PURCHASE-PLAN', DO: 'DISTR-PLAN', PLAN_purchase: 'PURCHASE-PLAN', PLAN_transfer: 'DISTR-PLAN', PLAN_consignment: 'DISTR-PLAN',
    PLAN_purchase_dev: 'PURCHASE-PLAN', PLAN_transfer_dev: 'DISTR-PLAN', PLAN_consignment_dev: 'DISTR-PLAN' }
const R_WITHDRAW = 'workflowReason-plan-withdraw'
const DECISION_OF_REASON = { 'workflowReason-plan-process-until': 'process_until', 'workflowReason-approve': 'approve', 'workflowReason-reapprove': 'confirm',
    [R_WITHDRAW]: 'withdraw', 'workflowReason-plan-edit-after-approval': 'edit', 'workflowReason-plan-autoplan-changed': 'changed' }

const isObj = (x) => !!(x && typeof x === 'object' && !Array.isArray(x))
const str = (v) => (v === undefined || v === null) ? '' : String(v).trim()

export function planApproval_on(setting) {
    try { return typeof setting === 'function' ? setting(PLAN_APPROVAL_FLAG, true) !== false : true } catch (e) { return true }
}

// 'PURCHASE-PLAN' | 'PO' | мера вида 'PLAN_purchase' → сегмент плана снабжения; '' — не ЗП / DO
export function planApproval_segmentOf(x) {
    const s = str(x)
    if (SEGMENTS.includes(s)) return s
    return ALIAS[s] || ALIAS[s.toUpperCase()] || ''
}

// WHERE ячейки / строки ([[поле, значение]] или [{leftValue, condition, rightValue, attrs}]) → {поле: значение} (как plan_docs_balance._where_pairs: имя — после последней точки)
export function planApproval_pairs(where, out = {}) {
    for (const w of Array.isArray(where) ? where : []) {
        if (Array.isArray(w) && w.length >= 2) { const k = str(w[0]).split('.').pop(); if (k && !(k in out) && w[1] !== '' && w[1] !== null && w[1] !== undefined) out[k] = w[1]; continue }
        if (!isObj(w) || w.use === false) continue
        const lv = w.leftValue, k = str(isObj(lv) ? lv.value : lv).split('.').pop()
        const cond = str(w.condition || '=').toLowerCase()
        if (k && (cond === '=' || cond === 'in') && !(k in out)) {
            const rv = isObj(w.rightValue) ? w.rightValue.value : w.rightValue
            const vals = Array.isArray(w.attrs) && w.attrs.length
                ? w.attrs.filter(a => isObj(a) && a.use !== false).map(a => (isObj(a.rightValue) ? a.rightValue.value : a.rightValue)).filter(v => v !== '' && v !== null && v !== undefined && v !== '<isempty>')
                : (rv !== '' && rv !== null && rv !== undefined ? [rv] : [])
            if (vals.length === 1) out[k] = vals[0]
            else if (vals.length > 1) out[k] = vals
        }
        if (Array.isArray(w.WHERE)) planApproval_pairs(w.WHERE, out)
    }
    return out
}

// сегмент строки по её WHERE: plan_segment, иначе мера вида в measure_type / measure ('' — не строка ЗП / DO).
// IE 2026 11 03 / ODOO-5800 (ревью этапа B): как plan_docs_balance.segment_of бэка — только имя сегмента и меры вида PLAN_*; 'PO' / 'DO' в WHERE — тип движения 1С
// (TXN, факт), не план: короткие коды здесь не принимаются (иначе раздел и пилюля — у строк движений и в чужих отчётах)
function _whereSeg(v) {
    const s = str(v)
    return SEGMENTS.includes(s) ? s : (s.startsWith('PLAN_') && ALIAS[s]) || ''
}
export function planApproval_whereSegment(where) {
    const p = isObj(where) ? where : planApproval_pairs(where)
    for (const k of ['plan_segment', 'measure_type', 'measure']) { const s = _whereSeg(Array.isArray(p[k]) ? '' : p[k]); if (s) return s }
    return ''
}

// state / status бэка ('statusPlan-processed', 'approved-changed', …) → state; прочее — autoplan
export function planApproval_state(x) {
    const s = str(isObj(x) ? (x.state || x.status) : x).toLowerCase().replace(/^statusplan-/, '').replace(/_/g, '-')
    if (s === 'changed' || s === 'approvedchanged') return 'approved-changed'
    return STATES.includes(s) ? s : 'autoplan'
}
export function planApproval_rank(state) { return RANK[planApproval_state(state)] || 0 }
export function planApproval_worst(states) {
    let best = 'autoplan'
    for (const s of Array.isArray(states) ? states : []) { const st = planApproval_state(s); if (RANK[st] > RANK[best] || (best === 'autoplan' && st === 'withdrawn')) best = st }
    return best
}
export function planApproval_isActive(state) { return ACTIVE.includes(planApproval_state(state)) }

// 'YYYY-MM-DD' настоящей даты
export function planApproval_dateOk(d) {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(str(d))
    if (!m) return false
    const dt = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3]))
    return dt.getUTCFullYear() === +m[1] && dt.getUTCMonth() === +m[2] - 1 && dt.getUTCDate() === +m[3]
}
// '2026-11-15' → '15.11.2026' (short — '15.11'); не дата — как есть
export function planApproval_dateText(d, short = false) {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(str(d))
    return m ? (short ? m[3] + '.' + m[2] : m[3] + '.' + m[2] + '.' + m[1]) : str(d)
}
function _atText(v) { const m = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/.exec(str(v)); return m ? m[3] + '.' + m[2] + ' ' + m[4] + ':' + m[5] : planApproval_dateText(v, true) }

export function planApproval_segmentTitle(seg) {
    return planApproval_segmentOf(seg) === 'DISTR-PLAN' ? t('Transfer plan') : t('Purchase plan')
}
function _short(seg) { return planApproval_segmentOf(seg) === 'DISTR-PLAN' ? t('Transfers') : t('Purchases') }

export function planApproval_stateText(state, until = '') {
    switch (planApproval_state(state)) {
        case 'processed': return str(until) ? t('Processed until {date}', { date: planApproval_dateText(until) }) : t('Processed')
        case 'approved': return t('Approved')
        case 'approved-changed': return t('Changed after approval')
        case 'withdrawn': return t('Withdrawn')
        default: return t('Autoplan')
    }
}
// класс тона (кнопка / чип / пилюля): pa-tone-autoplan | processed | approved | changed | withdrawn
export function planApproval_tone(state) {
    const s = planApproval_state(state)
    return 'pa-tone-' + (s === 'approved-changed' ? 'changed' : s)
}

export function planApproval_decisionTitle(decision, until = '') {
    switch (decision) {
        case 'process_until': return str(until) ? t('Processed until {date}', { date: planApproval_dateText(until) }) : t('Processed until…')
        case 'approve': return t('Approve the whole horizon')
        case 'confirm': return t('Confirm the approval')
        case 'withdraw': return t('Withdraw approval')
        case 'history': return t('History')
        default: return str(decision)
    }
}

// ----- сводка (plan_decision_summary) и кнопка шапки -----
export function planApproval_summary(raw) {
    const r = isObj(raw) ? raw : {}
    const segs = isObj(r.segments) ? r.segments : {}
    const out = { state: str(r.state) || (Object.keys(segs).length ? 'ok' : 'empty'), off: str(r.state) === 'off', error: str(r.state).startsWith('error') ? str(r.state) : '',
        version: str(r.version), segments: [], worst: 'autoplan', keys: 0 }
    for (const seg of SEGMENTS) {
        const s = isObj(segs[seg]) ? segs[seg] : null
        if (!s) continue
        const n = (k) => Math.max(0, Number(s[k]) || 0)
        const keys = n('keys')
        const st = keys ? planApproval_state(s.state || s.status) : 'autoplan'
        const last = isObj(s.last) ? { state: planApproval_state(s.last.state), by: str(s.last.by), at: str(s.last.at), reason: str(s.last.reason), comment: str(s.last.comment), until: str(s.last.until) } : null
        out.segments.push({ segment: seg, title: planApproval_segmentTitle(seg), keys, state: st, untilMin: str(s.until_min), untilMax: str(s.until_max),
            counts: { autoplan: n('autoplan'), processed: n('processed'), approved: n('approved'), changed: n('approved-changed') || n('changed'), withdrawn: n('withdrawn') },
            decided: n('processed') + n('approved') + (n('approved-changed') || n('changed')), last: last && (last.at || last.by) ? last : null })
        out.keys += keys
    }
    out.worst = planApproval_worst(out.segments.filter(s => s.keys).map(s => s.state))
    return out
}

// чип вида плана на кнопке: «Purchases · until 15.11», «Transfers · ✓»
export function planApproval_chip(s) {
    if (!isObj(s) || !s.keys) return null
    const tail = s.state === 'processed' ? t('until {date}', { date: planApproval_dateText(s.untilMin || s.untilMax, true) })
        : s.state === 'approved' ? '✓' : s.state === 'approved-changed' ? t('changed') : s.state === 'withdrawn' ? t('withdrawn') : t('autoplan')
    return { segment: s.segment, text: _short(s.segment) + ' · ' + tail, tone: planApproval_tone(s.state) }
}

// строка вида плана в меню: «Purchase plan — Processed until 15.11.2026 · 1 position · Supplier… · ivan 30.10 09:12»
export function planApproval_segmentLine(s, reasonTitle = (x) => x) {
    if (!isObj(s)) return ''
    const parts = [s.title + ' — ' + planApproval_stateText(s.state, s.untilMin || s.untilMax), tn(s.keys, '{n} position', '{n} positions')]
    if (s.keys > 1 && s.decided && s.decided < s.keys) parts.push(t('mixed: {a} approved · {p} processed · {c} changed · {o} autoplan', { a: s.counts.approved, p: s.counts.processed, c: s.counts.changed, o: s.counts.autoplan + s.counts.withdrawn }))
    if (s.last) {
        if (s.last.reason) parts.push(t('reason: {r}', { r: reasonTitle(s.last.reason) }))
        if (s.last.by || s.last.at) parts.push([s.last.by, _atText(s.last.at)].filter(Boolean).join(' '))
    }
    return parts.join(' · ')
}

// пункты меню вида плана (без заголовка): approve — не все позиции утверждены; process_until — всегда; confirm — есть approved-changed; withdraw — есть решение
export function planApproval_actionsOf(s) {
    if (!isObj(s) || !s.keys) return []
    const out = []
    if (s.counts.approved < s.keys) out.push('approve')
    out.push('process_until')
    if (s.counts.changed) out.push('confirm')
    if (s.decided) out.push('withdraw')
    out.push('history')
    return out
}

// IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239): подпись кнопки шапки как в прототипе (раздел 1) — чипы видов плана и «Plan approval ▾»;
// wj-menu.header — innerHTML, поэтому текст экранирован; ширина задаётся подписью, наведение меняет только цвет (стили — AttrMenu.vue, .pa-hdr)
const _esc = (v) => String(v === undefined || v === null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
export function planApproval_headerHtml(chips, label = '') {
    const cs = (Array.isArray(chips) ? chips : []).filter(isObj).map(c => `<span class="pa-chip ${_esc(c.tone)}" data-pa-chip="${_esc(c.segment)}">${_esc(c.text)}</span>`).join('')
    return `<span class="pa-hdr">${cs}<span class="pa-hdr-label">${_esc(label || t('Plan approval'))}</span><i class="pi pi-angle-down pa-hdr-caret"></i></span>`
}

const ICON = { approve: 'pi-check', process_until: 'pi-calendar', confirm: 'pi-check-circle', withdraw: 'pi-undo', history: 'pi-history' }

// кнопка-меню шапки (AttrMenu командной панели грида); summary — planApproval_summary | null (идёт загрузка); ctx {source_name, binding, reasons, today}
export function planApproval_menu(summary, ctx = {}) {
    const base = { name: 'button-plan-approval-menu', attr_type: 'AttrMenu', autoGeneratedButton: true, showCommandTitle: true, uiHelp: 'planApproval.menu' }   // подпись с чипами видна на кнопке
    const item = (o) => { const a = { attr_type: 'AttrButton', command: 'executeVueObjMethod', method: 'planApproval_run', uiHelp: 'planApproval.menu', ...o }
        if (str(ctx.source_name)) a.source_name = ctx.source_name
        if (str(ctx.binding)) a.binding = ctx.binding
        return a }
    if (!isObj(summary)) return { ...base, title: t('Plan approval'), tooltip: t('Plan approval'), cssClass: 'pa-btn pa-btn-labelled pa-tone-autoplan', headerHtml: planApproval_headerHtml([]), pa_chips: [], attrs: [{ name: 'button-pa-loading', attr_type: 'AttrButton', title: t('Loading…'), disabled: true }] }
    const segs = summary.segments.filter(s => s.keys)
    const chips = segs.map(planApproval_chip).filter(Boolean)
    const reasons = planApproval_reasons(ctx.reasons)
    const rTitle = (id) => (reasons.find(r => r.id === id) || {}).title || id
    const attrs = []
    for (const s of segs) {
        if (attrs.length) attrs.push({ title: '-' })
        attrs.push({ name: 'button-pa-head-' + s.segment, attr_type: 'AttrButton', title: planApproval_segmentLine(s, rTitle), disabled: true, cssClass: 'pa-menu-head ' + planApproval_tone(s.state) })
        for (const d of planApproval_actionsOf(s)) {
            const a = item({ name: 'button-pa-' + d + '-' + s.segment, title: d === 'process_until' ? t('Processed until…') : d === 'confirm' ? t('Confirm the approval') : d === 'withdraw' ? t('Withdraw approval') : d === 'approve' ? t('Approve') : t('History'),
                cssClass: 'pi p-button-white ' + ICON[d], pa_segment: s.segment, pa_decision: d })
            Object.assign(a, planApproval_inputOf(d, { reasons, today: ctx.today, keys: s.keys }))
            attrs.push(a)
        }
    }
    if (!segs.length) attrs.push({ name: 'button-pa-empty', attr_type: 'AttrButton', title: summary.off ? t('Plan approval is switched off') : (summary.error || t('No purchase or transfer plan positions in the report')), disabled: true })
    const title = chips.length ? chips.map(c => c.text).join('  ') + '  ' + t('Plan approval') : t('Plan approval')
    return { ...base, title, tooltip: t('Plan approval'), cssClass: 'pa-btn pa-btn-labelled ' + planApproval_tone(summary.worst), headerHtml: planApproval_headerHtml(chips), pa_chips: chips, attrs }   // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239): без иконки-глифа на хосте (.pi ставил шрифт primeicons подписи), подпись и чипы — headerHtml
}

// поля окна ввода (store.confirmInput) для решений с обязательными полями: process_until — дата, причина (одна), комментарий; withdraw — комментарий
export function planApproval_inputOf(decision, ctx = {}) {
    if (decision === 'process_until') {
        return { confirm: t('Months up to the date are fixed from the autoplan; after the date the autoplan stays live. A reason and a comment are required.'),
            confirm_input: { field: 'comment', label: t('Comment'), value: '', required: true, date: { field: 'until', label: t('Processed until'), value: str(ctx.today) },
                options: planApproval_reasons(ctx.reasons).map(r => ({ field: 'reason', value: r.id, label: r.title })), exclusive: true, optionsRequired: true } }
    }
    if (decision === 'withdraw') return { confirm: t('The plan returns to the autoplan; the saved edits stay in the history. A comment is required.'), confirm_input: { field: 'comment', label: t('Comment'), value: '', required: true } }
    return {}
}

// справочник причин: записи itemsSource['PLAN-DECISION-REASON'] ({data: [{id, title}]} | [{id, title}]) без архивных, иначе умолчания (подписи — t())
export function planApproval_reasons(src) {
    const list = Array.isArray(src) ? src : (isObj(src) && Array.isArray(src.data) ? src.data : null)
    const out = (list || []).filter(r => isObj(r) && str(r.id) && r.archived !== true && r.use !== false).map(r => ({ id: str(r.id), title: str(r.title) || str(r.id) }))
    return out.length ? out : DEFAULT_REASONS.map(r => ({ id: r.id, title: t(r.title) }))
}

// ----- запись решения -----
// обязательные поля (как plan_approval_v3.validate): '' — можно отправлять
export function planApproval_validate(decision, f = {}) {
    const x = isObj(f) ? f : {}
    if (!DECISIONS.includes(decision)) return t('Choose the decision')
    if (decision === 'process_until') {
        if (!planApproval_dateOk(x.until)) return t('Set the date until which the plan is processed')
        if (!str(x.reason)) return t('Choose the reason of the decision')
        if (!str(x.comment)) return t('A comment is required')
    }
    if (decision === 'withdraw' && !str(x.comment)) return t('A comment is required')
    return ''
}

export function planApproval_scopeObjects(objects, segment) {
    const objs = [...new Set((Array.isArray(objects) ? objects : []).map(str).filter(Boolean))]
    const seg = planApproval_segmentOf(segment)
    return objs.length && seg ? { objects: objs, segment: seg } : null
}

// params метода plan_decision → {params} | {error}
export function planApproval_request(decision, scope, f = {}, dry = true) {
    const why = planApproval_validate(decision, f)
    if (why) return { error: why }
    if (!isObj(scope) || !(scope.where || scope.keys || scope.objects)) return { error: t('No plan rows found for the decision') }
    const x = isObj(f) ? f : {}
    const params = { decision, scope, dry: !!dry }
    if (decision === 'process_until') { params.until = str(x.until); params.reason = str(x.reason) }
    if (str(x.comment)) params.comment = str(x.comment)
    if (str(x.reason) && !params.reason) params.reason = str(x.reason)
    if (Array.isArray(x.months) && x.months.length === 2) params.months = x.months.map(str)
    return { params }
}

// IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239): preview.title бэка — supply_flat.title_of(key) = id измерений через « · »
// (object · subject_from · subject_to …: GUID 1С, проба p239). Названия — из уже загруженных данных отчёта: store.itemsSource[*].ids (словари Link-колонок), поля
// строк «<поле>-title» (shownTitle), DataMap колонок. Не найдено — часть остаётся как есть (честно, без догадки)
export const GUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
export function planApproval_titleResolver(src = {}) {
    const its = isObj(src.itemsSource) ? src.itemsSource : null
    const maps = (Array.isArray(src.dataMaps) ? src.dataMaps : []).filter(m => m && typeof m.getDisplayValue === 'function')
    const memo = new Map()
    let byRow = null
    const rowMap = () => {
        if (byRow) return byRow
        byRow = new Map()
        const rows = Array.isArray(src.rows) ? src.rows : []
        const lim = Math.min(rows.length, Number(src.limit) || 20000)
        for (let i = 0; i < lim; i++) {
            const it = rows[i]
            if (!isObj(it)) continue
            for (const k of Object.keys(it)) {
                if (!k.endsWith('-title')) continue
                const id = it[k.slice(0, -6)], tt = str(it[k])
                if (typeof id === 'string' && id && tt && tt !== id && !byRow.has(id)) byRow.set(id, tt)
            }
        }
        return byRow
    }
    return (id) => {
        const k = str(id)
        if (!k) return ''
        if (memo.has(k)) return memo.get(k)
        let out = ''
        if (its) {
            for (const seg of Object.keys(its)) {
                const ids = isObj(its[seg]) && isObj(its[seg].ids) ? its[seg].ids : null
                const rec = ids && ids[k]
                const tt = isObj(rec) ? str(rec.title || rec.name) : ''
                if (tt && tt !== k) { out = tt; break }
            }
        }
        if (!out) out = rowMap().get(k) || ''
        if (!out) for (const m of maps) { try { const v = str(m.getDisplayValue(k)); if (v && v !== k) { out = v; break } } catch (e) { /* DataMap без значения */ } }
        memo.set(k, out)
        return out
    }
}
// служебное название позиции (« · »-список id) → названия; titleOf — planApproval_titleResolver (нет — как есть)
export function planApproval_humanTitle(title, titleOf) {
    const s = str(title)
    if (!s || typeof titleOf !== 'function') return s
    return s.split(' · ').map(p => { const v = str(p); if (!v) return v; let tt = ''; try { tt = str(titleOf(v)) } catch (e) { tt = '' } return tt || v }).join(' · ')
}

// ответ plan_decision → {ok, message, dry, keys, rows, preview: [{key, title, segment, stateFrom, stateText, months}], refused: [{key, title, why}]}; titleOf — названия вместо id (planApproval_humanTitle)
export function planApproval_result(raw, dry = false, titleOf = null) {
    const r = isObj(raw) ? raw : {}
    const preview = (Array.isArray(r.preview) ? r.preview : []).filter(isObj).map(p => ({ key: str(p.key_id), title: planApproval_humanTitle(str(p.title) || str(p.key_id), titleOf), segment: str(p.segment),
        stateFrom: planApproval_state(p.state_from), stateText: planApproval_stateText(p.state_from), months: Array.isArray(p.months) ? p.months.length : (Number(p.months) || 0) }))
    const refused = (Array.isArray(r.refused) ? r.refused : []).filter(isObj).map(x => ({ key: str(x.key), title: planApproval_humanTitle(str(x.title) || str(x.key), titleOf), why: str(x.why) }))
    return { ok: r.ok === true, message: str(r.message) || (r.ok === true ? '' : t('The decision is not saved')), dry: !!dry, decision: str(r.decision), state: str(r.state),
        keys: Number(r.keys) || preview.length, rows: Number(r.rows) || 0, preview, refused }
}

// IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239): подписи кнопок окна подтверждения — «Cancel» и действие решения (не «Ні» / «Так»)
export function planApproval_acceptLabel(decision) {
    switch (decision) {
        case 'approve': return t('Approve')
        case 'process_until': return t('Mark processed')
        case 'withdraw': return t('Withdraw')
        case 'confirm': return t('Confirm')
        default: return t('Save the decision')
    }
}
export function planApproval_confirmLabels(decision) { return { acceptLabel: planApproval_acceptLabel(decision), rejectLabel: t('Cancel') } }

// текст подтверждения по ответу dry: решение, число позиций, список (до max), отказы
export function planApproval_previewText(res, decision, until = '', max = 8) {
    if (!isObj(res)) return ''
    const n = res.preview.length
    const head = planApproval_decisionTitle(decision, until) + ': ' + tn(n, '{n} plan position', '{n} plan positions')
    const list = res.preview.slice(0, max).map(p => p.title + ' (' + p.stateText + (p.months ? ', ' + tn(p.months, '{n} month', '{n} months') : '') + ')')
    if (n > max) list.push(t('and {n} more', { n: n - max }))
    const parts = [head + (list.length ? ' — ' + list.join('; ') : '')]
    if (res.refused.length) parts.push(tn(res.refused.length, '{n} position is skipped: {why}', '{n} positions are skipped: {why}', { why: res.refused[0].why }))
    parts.push(t('Save the decision?'))
    return parts.join('. ')
}

// вызов метода чтения (summary / history): ответ нужен только вызывающему (команда ответа снимается — как у cell_passport)
// IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239):
//   dry plan_decision — уведомление ответа (TERMINAL бэка «… (preview)») тостом не показывается: у dry только окно подтверждения (хук стора _muteNotification);
//   запрос упал без ответа (HTTP-ошибка, обрыв, отказ роли) — cb(null) один раз (хуки _onResponse(null) / _onAbort): вызывающий снимает «занято»
export function planApproval_muteDry(answer) { return !!(isObj(answer) && isObj(answer.plan_decision)) }
export function planApproval_call(grid, method, params, cb) {
    const store = grid && grid.store
    const p = isObj(params) ? params : {}
    let settled = false
    const fin = (answer) => { if (settled) return; settled = true; if (typeof cb === 'function') cb(answer || null) }
    if (!store || typeof store.executeWidgetMethod !== 'function') { fin(null); return false }
    const action = { command: 'executeWidgetMethod', method, params: p,
        record_sendToBackend_exclude: ['_doc'], widget_sendToBackend_exclude: ['view'], no_del_last_backend_action: true,
        _response_callback: (answer) => { if (answer) { answer.command = ''; delete answer.updates } fin(answer) },
        _onResponse: (a) => { if (a === null) fin(null) }, _onAbort: () => fin(null) }
    if (method === METHODS.decide && p.dry === true) action._muteNotification = planApproval_muteDry
    try { store.executeWidgetMethod({ WIDGET: grid.WIDGET }, action) } catch (e) { fin(null); return false }
    return true
}

// решение: dry → подтверждение списка позиций (req.confirm(text, accept)) → настоящий вызов на виджете (ответ несёт данные отчёта — перечитывание штатным updateDoc)
// req {decision, scope, form, confirm, note, done(res)}; false — не отправлено (ошибка — в note / done)
export function planApproval_decide(grid, req) {
    const r = isObj(req) ? req : {}
    const note = typeof r.note === 'function' ? r.note : () => {}
    let finished = false   // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239): итог — ровно один раз (ответ / ошибка запроса / отмена окна)
    const done = (x) => { if (finished) return; finished = true; if (typeof r.done === 'function') r.done(x) }
    const q = planApproval_request(r.decision, r.scope, r.form, true)
    if (q.error) { note(q.error, 'warning'); done({ ok: false, message: q.error, stage: 'validate' }); return false }
    const store = grid && grid.store
    if (!store || typeof store.executeWidgetMethod !== 'function') { done({ ok: false, message: t('The decision is not saved'), stage: 'validate' }); return false }
    planApproval_call(grid, METHODS.decide, q.params, (answer) => {
        const res = planApproval_result(answer && answer.plan_decision, true, r.titleOf)
        if (!res.ok) { note(answer ? res.message : t('No answer from the server'), 'warning'); done({ ...res, message: answer ? res.message : t('No answer from the server'), stage: 'dry' }); return }
        const go = () => {
            const real = { ...q.params, dry: false }
            const target = (grid.WIDGET && grid.WIDGET.vueObj) || grid
            const lost = () => { const m = t('No answer from the server'); note(m, 'warning'); done({ ok: false, message: m, stage: 'write' }) }
            try {
                store.executeWidgetMethod(target, { command: 'executeWidgetMethod', method: METHODS.decide, params: real, record_sendToBackend_exclude: ['_doc'], widget_sendToBackend_exclude: ['view'],
                    _response_callback: (ans) => { if (finished) return; const fin = planApproval_result(ans && ans.plan_decision, false, r.titleOf); note(fin.message, fin.ok ? 'success' : 'warning'); done({ ...fin, stage: 'write' }) },
                    _onResponse: (a) => { if (a === null) lost() }, _onAbort: lost })
            } catch (e) { lost() }
        }
        const text = planApproval_previewText(res, r.decision, r.form && r.form.until)
        if (typeof r.confirm === 'function') r.confirm(text, go, () => done({ ...res, stage: 'cancel' }), r.decision)
        else done({ ...res, stage: 'cancel' })   // IE 2026 11 03 / ODOO-5800 (ревью этапа B): без окна подтверждения запись не уходит
    })
    return true
}

// ----- история (plan_decision_history) -----
function _eventState(e) {
    if (str(e.reason) === R_WITHDRAW) return 'withdrawn'
    return planApproval_state(e.status_to)
}
// события → строки списка раздела формы ячейки (новые сверху)
export function planApproval_historyRows(events, reasons) {
    const rs = planApproval_reasons(reasons)
    const rTitle = (id) => (rs.find(r => r.id === id) || {}).title || str(id)
    return (Array.isArray(events) ? events : []).filter(isObj).map((e, i) => {
        const st = _eventState(e), dec = DECISION_OF_REASON[str(e.reason)] || ''
        const what = dec === 'changed' ? t('Autoplan changed') : dec === 'edit' ? t('Edited after approval') : planApproval_stateText(st, e.until_date)
        return { key: str(e.at) + ':' + i, at: str(e.at), atText: _atText(e.at), state: st, tone: planApproval_tone(dec === 'changed' ? 'approved-changed' : st), text: what,
            who: str(e.source) === 'recalc' ? t('Recalculation') : str(e.user), comment: str(e.comment), reason: str(e.category) ? rTitle(e.category) : '', months: Array.isArray(e.months) ? e.months.map(str) : [] }
    }).sort((a, b) => (a.at < b.at ? 1 : a.at > b.at ? -1 : 0))
}

// события → список единиц окна History (store.approvalHistory_open: [{unit, title, status, events}]) — по ключу плана
export function planApproval_historyUnits(events, opts = {}) {
    const rs = planApproval_reasons(opts.reasons)
    const rTitle = (id) => (rs.find(r => r.id === id) || {}).title || str(id)
    const by = new Map()
    for (const e of (Array.isArray(events) ? events : []).filter(isObj)) {
        const k = str(e.key_id) || '-'
        if (!by.has(k)) by.set(k, [])
        by.get(k).push(e)
    }
    const out = []
    for (const [k, evs] of by) {
        const sorted = evs.slice().sort((a, b) => (str(a.at) < str(b.at) ? 1 : -1))
        const st = _eventState(sorted[0])
        out.push({ unit: k, title: (typeof opts.titleOf === 'function' && str(opts.titleOf(k))) || k, status: 'statusPlan-' + st, status_title: planApproval_stateText(st, sorted[0].until_date),
            events: sorted.map((e, i) => {
                const est = _eventState(e), dec = DECISION_OF_REASON[str(e.reason)] || ''
                return { id: k + ':' + i, at: str(e.at), user_name: str(e.source) === 'recalc' ? '' : str(e.user), user_ref: str(e.source) === 'recalc' ? { system: true } : undefined,
                    reason: str(e.reason), reason_title: dec === 'changed' ? t('Autoplan changed') : dec === 'edit' ? t('Edited after approval') : planApproval_decisionTitle(dec, e.until_date) || str(e.reason),
                    status_from: str(e.status_from), status_from_title: planApproval_stateText(e.status_from), status_to: str(e.status_to), status_to_title: planApproval_stateText(est, e.until_date),
                    comment: str(e.comment), category: str(e.category) ? rTitle(e.category) : '', changed_periods: Array.isArray(e.months) ? e.months.map(str) : [], source: str(e.source) }
            }) })
    }
    return out
}

// ----- раздел формы ячейки -----
// состояние ключа ячейки по последнему событию истории (новое сверху); событий нет — autoplan
export function planApproval_cellState(events) {
    const evs = (Array.isArray(events) ? events : []).filter(e => isObj(e) && DECISION_OF_REASON[str(e.reason)] !== 'edit')
        .sort((a, b) => (str(a.at) < str(b.at) ? 1 : str(a.at) > str(b.at) ? -1 : 0))
    const ev = evs[0]
    if (!ev) return { state: 'autoplan', until: '', at: '' }
    const st = _eventState(ev)
    return { state: st, until: st === 'processed' || st === 'approved-changed' ? str(ev.until_date) : '', at: str(ev.at) }
}

// модель раздела: segment — сегмент строки; history — ответ plan_decision_history (null — идёт загрузка)
export function planApproval_formModel(opt = {}) {
    const seg = planApproval_segmentOf(opt.segment)
    if (!seg) return null
    const h = isObj(opt.history) ? opt.history : null
    const events = h && Array.isArray(h.events) ? h.events : []
    const cs = planApproval_cellState(events)
    const stateText = planApproval_stateText(cs.state, cs.until)
    return { segment: seg, title: planApproval_segmentTitle(seg), loading: !h, off: !!(h && h.state === 'off'), error: h && str(h.state).startsWith('error') ? str(h.state) : '',
        state: cs.state, until: cs.until, stateText, tone: planApproval_tone(cs.state), locked: planApproval_isActive(cs.state),
        canConfirm: cs.state === 'approved-changed', canWithdraw: planApproval_isActive(cs.state),
        rows: planApproval_historyRows(events, opt.reasons).slice(0, Number(opt.max) || 12), n: events.length,
        summary: stateText + (events.length ? ' · ' + tn(events.length, '{n} decision', '{n} decisions') : '') }
}

// форма раздела {choice: approve | process_until | withdraw | confirm, until, reason, comment} → решение + поля
export function planApproval_formDecision(form) {
    const f = isObj(form) ? form : {}
    const d = str(f.choice)
    return DECISIONS.includes(d) ? { decision: d, form: { until: str(f.until), reason: str(f.reason), comment: str(f.comment) } } : null
}

// ----- пилюля строки Баланса -----
// decision строки (DS-PLAN-DOCS этапа C: dataItem.decision {state, until} | dataItem.decision_state / decision_until | _DLRow.decision); нет — null
export function planApproval_rowDecision(dataItem) {
    const it = isObj(dataItem) ? dataItem : null
    if (!it) return null
    const d = isObj(it.decision) ? it.decision : (isObj(it._DLRow) && isObj(it._DLRow.decision) ? it._DLRow.decision : null)
    if (d && str(d.state)) return { state: planApproval_state(d.state), until: str(d.until) }
    if (str(it.decision_state)) return { state: planApproval_state(it.decision_state), until: str(it.decision_until) }
    return null
}
// состояние пилюли: decision строки, иначе сводка вида плана, если в отборе ОДНА позиция этого вида (сводка однозначна); autoplan / неизвестно — null (пилюли нет)
export function planApproval_rowState(dataItem, segment, summary) {
    const own = planApproval_rowDecision(dataItem)
    let st = null
    if (own) st = { ...own, source: 'row' }
    else if (isObj(summary) && planApproval_segmentOf(segment)) {
        const s = (summary.segments || []).find(x => x.segment === planApproval_segmentOf(segment))
        if (s && s.keys === 1) st = { state: s.state, until: s.untilMax || s.untilMin, source: 'summary' }
    }
    if (!st || st.state === 'autoplan') return null
    return { ...st, text: planApproval_stateText(st.state, st.until), tone: planApproval_tone(st.state), locked: planApproval_isActive(st.state) }
}
// HTML пилюли (escape — экранирование стора): замок pi-lock у действующего решения
export function planApproval_pillHtml(rs, escape = (v) => String(v)) {
    if (!isObj(rs)) return ''
    return `<span class="status-chip pa-pill ${escape(rs.tone)}" data-pa-state="${escape(rs.state)}" data-pa-source="${escape(rs.source || '')}">${rs.locked ? '<i class="pi pi-lock pa-lock"></i>' : ''}${escape(rs.text)}</span>`
}

// объекты строк отчёта (WHERE строки _DLRow.where и поле object) — скоуп кнопки шапки; limit — предел перебора строк
export function planApproval_objectsOfRows(items, limit = 20000) {
    const out = new Set()
    const list = Array.isArray(items) ? items : []
    for (let i = 0; i < list.length && i < limit; i++) {
        const it = list[i]
        if (!isObj(it)) continue
        const p = planApproval_pairs(isObj(it._DLRow) ? it._DLRow.where : null)
        const o = p.object !== undefined ? p.object : it.object
        if (Array.isArray(o)) o.forEach(v => { if (str(v)) out.add(str(v)) })
        else if (str(o) && typeof o !== 'object') out.add(str(o))
    }
    return [...out]
}
// есть ли в отчёте строки ЗП / DO (по WHERE строки и отбору узла раскладки) — кнопка нужна только Балансу
export function planApproval_hasPlanRows(items, limit = 20000) {
    const list = Array.isArray(items) ? items : []
    for (let i = 0; i < list.length && i < limit; i++) {
        const d = isObj(list[i]) ? list[i]._DLRow : null
        if (!isObj(d)) continue
        if (planApproval_whereSegment(d.where) || planApproval_whereSegment(d.where_block)) return true
    }
    return false
}
